/**
 * Lệnh Bot — Rename Page navigation config.
 */

export const RENAME_PAGE_ROUTE_NAME = 'LenhBotRenamePage'
export const RENAME_PAGE_ITEM_ID    = 'lenh-bot-rename-page'
export const RENAME_PAGE_LABEL      = 'Rename Page'
export const RENAME_PAGE_TITLE      = 'Lệnh Bot · Rename Page'
